const objContext = JSON.parse(sessionStorage.getItem("context"));
if (objContext == null || objContext.store_name == null)
    location.href = 'index.html';
var id_current_store = null, url_picture = null, objStoreInfo = null;

const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab'),
    selectMenu = document.querySelector("#selectMenuTags"),
    selectCategories = document.querySelector("#selectCategoryTags"),
    selectProduct = document.querySelector("#selectProductTags"),
    inputSearch = document.querySelector('#searchTag'),
    containerResultSuggest = document.querySelector('#suggest-containter'),
    labelContainerSuggest = document.querySelector('.label-suggest'),

    btnUpdateProduct = document.querySelector('#btn-save-tags'),
    containerTagsAdded = document.querySelector('.tags-added-container');

if (sectionTab != null)
    sectionTab[7].classList.add('sidebar-menu-container-section-tab--active');

let arrayPreviousTagsProduct = [],
    arrayDeletePreviousTagProduct = [],
    arrayNewTagsProduct = [];

//let isActiveBtn = false


document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

window.addEventListener("load", loadPage);
function loadPage() {
    id_current_store = localStorage.getItem("currentStore");
    labelContainerSuggest.textContent = "";
    containerResultSuggest.innerHTML = "";

    if (id_current_store == null || objContext == null)
        location.href = 'index.html';
    else {
        document.querySelector('.sidebar-profile-img img').src = objContext.store_image
        document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')

        loadSelectMenus();
    }
}

// load selects
var menuData = null;

function loadSelectMenus() {
    UI.showLoader();

    fetch(
        BASE_URLS.Dinny.api + `/stores/${id_current_store}?req_id=${new Date().getTime()}`,
        {
            credentials: 'include'
        }
    ).then(function (response) {
        if (response.ok) {
            UI.hideLoader();
            selectMenu.innerHTML = '<option value="0" hidden="" selected="">Selecciona un menú</option>';

            response.json().then(function (json) {
                objStoreInfo = json;

                if (objStoreInfo.menu && objStoreInfo.menu != null && objStoreInfo.menu.length > 0) {
                    objStoreInfo.menu.forEach((element) => {
                        selectMenu.insertAdjacentHTML(
                            'beforeend',
                            `<option value='${element.id}'>${element.name}</option>`
                        )
                    });
                } else {
                    UI.message({ title: 'No tienes menús en tu establecimiento', content: 'Para poder crear etiquetas es necesario que el establecimiento cuente al menos un menú sincronizado con Dinny.<br/><br/>Por favor, crea un menú en tu administrador y sincronízalo con Dinny para que puedas agregar etiquetas a los productos.', accept: 'Aceptar' }, function () {
                        location.href = 'index.html';
                    });
                    return;
                }

                let idMenu = sessionStorage.getItem('idmenu');
                if (idMenu != null && idMenu.length > 0) {
                    selectMenu.value = idMenu;
                    selectMenu.dispatchEvent(new Event('change'));
                    sessionStorage.removeItem("idmenu");
                }

            });
        } else {
            response.json().then(function (content) {
                if (403 == response.status) {
                    window.location.href = 'login.html'
                } else {
                    UI.hideLoader();
                    alert("Ocurrió un error al cargar la sección de etiquetas.", 'error')
                }
            })
        }
    }).catch(function () { UI.hideLoader() });
}

function loadSelectCategories(menuId) {
    let menu = objStoreInfo.menu.find(a => a.id == menuId);
    menuData = menu;

    selectCategories.innerHTML = '<option value="0" hidden="" selected="">Selecciona una categoría</option>';
    menu.categories.forEach((category) => {
        selectCategories.insertAdjacentHTML(
            'beforeend',
            `<option value='${category.id}'>${category.name}</option>`
        )
    });
}

function loadSelectProducts(categoryId) {
    let category = menuData.categories.find(element => element.id == categoryId);
    selectProduct.innerHTML = '<option value="0" hidden="" selected="">Selecciona un producto</option>';

    category.products.forEach((product) => {
        selectProduct.insertAdjacentHTML(
            'beforeend',
            `<option value='${product.id}'>${product.name}</option>`
        );
    });
}


function addTagtoDOM(e) {
    let nameTag = e.target.parentNode.querySelector('.tag-name').textContent.toLowerCase();

    // revisar si etiquetas previamente cargadas se eliminaron y se volvieron a cargar a la lista.
    if (arrayDeletePreviousTagProduct.length != 0) {
        if (arrayDeletePreviousTagProduct.indexOf(nameTag) != -1) {
            arrayDeletePreviousTagProduct.splice(arrayDeletePreviousTagProduct.indexOf(nameTag), 1);
            arrayPreviousTagsProduct.push(nameTag);
            addIfNotExists(nameTag)
        } else {
            addIfNotExists(nameTag)
        }
    } else {
        addIfNotExists(nameTag)
    }

    function addIfNotExists(nameTag) {
        let tagExists = false

        for (let tIndex = 0; tIndex < document.querySelectorAll('.tag-added .tag-name').length; tIndex++) {
            const element = document.querySelectorAll('.tag-added .tag-name')[tIndex];
            console.log('etiqueta en dom', element.innerHTML)
            if (nameTag == element.innerHTML) {
                tagExists = true
                break;
            }
        }
        if (!tagExists) {
            /*
            isActiveBtn = true 
            btnUpdateProduct.classList.remove('btn-solid-default')
            btnUpdateProduct.classList.add('btn-solid-secondary')*/

            arrayNewTagsProduct.push(nameTag);
            containerTagsAdded.insertAdjacentHTML(
                'beforeend',
                `
                    <div class="tag-added">
                        <span class="tag-name">${nameTag}</span>
                        <span class="tag-delete" onclick="deleteTagtoDOM(event)"></span>
                    </div>
                `
            );
        } else {
            UI.message({
                title: 'Etiquetas',
                content: `La etiqueta ${nameTag} ya existe.`,
                accept: 'Aceptar'
            })
        }
    }


    e.target.parentNode.remove();
    labelContainerSuggest.textContent = "";
    containerResultSuggest.innerHTML = "";
    inputSearch.value = "";
    inputSearch.focus()
}

function deleteTagtoDOM(e) {
    let nameTag = e.target.parentNode.querySelector('.tag-name').textContent;

    arrayNewTagsProduct.splice(arrayNewTagsProduct.indexOf(nameTag), 1);
    e.target.parentNode.remove();

    // Validate if tags area is empty for disable btn
    /*
    if(arrayNewTagsProduct.length == 0 && arrayDeletePreviousTagProduct.length == 0){
        isActiveBtn = false 
        btnUpdateProduct.classList.remove('btn-solid-secondary')
        btnUpdateProduct.classList.add('btn-solid-default')
    }*/
}

function deleteTagPrevious(e) {
    let nameTag = e.target.parentNode.querySelector('.tag-name').textContent;
    arrayDeletePreviousTagProduct.push(nameTag);

    arrayPreviousTagsProduct.splice(arrayPreviousTagsProduct.indexOf(nameTag), 1);
    e.target.parentNode.remove();

    // Validate if tags area is empty for disable btn
    /*
    if(arrayNewTagsProduct.length == 0 && arrayDeletePreviousTagProduct.length == 0){
        isActiveBtn = false 
        btnUpdateProduct.classList.remove('btn-solid-secondary')
        btnUpdateProduct.classList.add('btn-solid-default')
    }*/
}


// getSuggestions('lech')
function getSuggestions(word) {
    if (/^[a-z0-9áéíóúüÁÉÍÓÚÜ]{4,}$/ig.test(word)) {
        UI.showLoader()
        fetch(
            BASE_URLS.Dinny.api + `/product-tag/complete/${word}?req_id=${new Date().getTime()}`,
            {
                credentials: 'include'
            }
        ).then(function (response) {
            if (response.ok) {
                UI.hideLoader();

                response.json().then(function (json) {

                    if (json.length == 0) {
                        containerResultSuggest.innerHTML = "";
                        labelContainerSuggest.textContent = "Crear";
                        containerResultSuggest.insertAdjacentHTML(
                            'beforeend',
                            `
                                <div class="tag-to-add tag-create">
                                    <span class="tag-name">${word}</span>
                                    <span class="tag-add" onclick="addTagtoDOM(event);"></span>
                                </div>
                            `);
                    }
                    else {
                        containerResultSuggest.innerHTML = "";
                        labelContainerSuggest.textContent = "Sugerencias";
                        json.forEach(tag => {
                            containerResultSuggest.insertAdjacentHTML(
                                'beforeend',
                                `
                                    <div class="tag-to-add">
                                        <span class="tag-name">${tag.tag}</span>
                                        <span class="tag-add" onclick="addTagtoDOM(event);"></span>
                                    </div>
                                `
                            )
                        });
                    }
                });
            } else {
                response.json().then(function (content) {
                    if (403 == response.status) {
                        window.location.href = 'login.html'
                    } else {
                        UI.hideLoader();
                        UI.message({
                            title: 'Etiquetas',
                            content: 'Ocurrió un error al cargar las sugerencias. Por favor inténtalo nuevamente.',
                            accept: 'Aceptar'
                        })
                    }
                })
            }
        }).catch(function () {
            UI.hideLoader()
            UI.message({
                title: 'Etiquetas',
                content: 'Ocurrió un error. Por favor inténtalo nuevamente.',
                accept: 'Aceptar'
            })
        })
    }
}
//loadTags({store_id:'pim-42', menu_id:'46', category_id:'59', product_id:'33'})
function loadTags(data) {
    if (data.store_id) {
        if (data.menu_id) {
            if (data.category_id) {
                if (data.product_id) {
                    UI.showLoader()
                    fetch(
                        BASE_URLS.Dinny.api + `/product-tag/list/?store_id=${data.store_id}&menu_id=${data.menu_id}&category_id=${data.category_id}&product_id=${data.product_id}&req_id=${new Date().getTime()}`,
                        {
                            credentials: 'include'
                        }
                    ).then(function (response) {
                        if (response.ok) {
                            containerTagsAdded.innerHTML = ""
                            UI.hideLoader()
                            response.json().then(function (json) {
                                json.forEach(tag => {
                                    containerTagsAdded.insertAdjacentHTML(
                                        'beforeend',
                                        `
                                            <div class="tag-added">
                                                <span class="tag-name">${tag.tag}</span>
                                                <span class="tag-delete" onclick="deleteTagPrevious(event)"></span>
                                            </div>
                                        `
                                    );
                                    arrayPreviousTagsProduct.push(tag.tag);
                                })
                            /*
                            if(arrayPreviousTagsProduct.length > 0){
                                isActiveBtn = true
                                btnUpdateProduct.classList.remove('btn-solid-default')
                                btnUpdateProduct.classList.add('btn-solid-secondary')
                            }*/
                            })
                        } else {
                            response.json().then(function (content) {
                                if (403 == response.status) {
                                    window.location.href = 'login.html'
                                } else {
                                    if (content && content.message) {
                                        UI.message({
                                            title: 'Etiquetas',
                                            content: content.message,
                                            accept: 'Aceptar'
                                        })
                                    }
                                    UI.hideLoader()
                                    UI.message({
                                        title: '',
                                        content: 'Ocurrió un error al cargar las etiquetas. Por favor inténtalo nuevamente.',
                                        accept: 'Aceptar'
                                    })
                                }
                            })
                        }
                    }).catch(function () {
                        UI.hideLoader()
                        UI.message({
                            title: '',
                            content: 'Ocurrió un error. Por favor inténtalo nuevamente.',
                            accept: 'Aceptar'
                        })
                    })
                } else {
                    UI.message({
                        title: '',
                        content: 'El producto no es válido.',
                        accept: 'Aceptar'
                    })
                }
            } else {
                UI.message({
                    title: '',
                    content: 'La categoría no es válida.',
                    accept: 'Aceptar'
                })
            }
        } else {
            UI.message({
                title: '',
                content: 'El menú no es válido.',
                accept: 'Aceptar'
            })
        }
    } else {
        UI.message({
            title: '',
            content: 'El establecimiento no es válido.',
            accept: 'Aceptar'
        })
    }
}
// addTags({store_id: 'pim-42', menu_id: '46', category_id: '59', product_id: '33', tags:['X','Y','Z']})
function addTags(data, callback) {
    if (data.store_id) {
        if (data.menu_id) {
            if (data.category_id) {
                if (data.product_id) {
                    if (data.tags && data.tags.length > 0) {
                        let valid = true

                        for (let t = 0; t < data.tags.length; t++) {
                            const element = data.tags[t];
                            if (!/^[a-z0-9áéíóúüñÁÉÍÓÚÜÑ]+$/ig.test(element)) {
                                valid = false
                            }
                        }
                        if (!valid) {
                            return UI.message({
                                title: '',
                                content: 'Debes ingresar por lo menos una etiqueta.',
                                accept: 'Aceptar'
                            })
                        }
                        UI.showLoader()
                        fetch(
                            BASE_URLS.Dinny.api + `/product-tag/add/?store_id=${data.store_id}&menu_id=${data.menu_id}&category_id=${data.category_id}&product_id=${data.product_id}&req_id=${new Date().getTime()}`,
                            {
                                credentials: 'include',
                                method: 'post',
                                body: JSON.stringify({
                                    tags: data.tags
                                })
                            }
                        ).then(function (response) {
                            if (response.ok) {
                                UI.hideLoader()
                                callback()
                            } else {
                                if (403 == response.status) {
                                    window.location.href = 'login.html'
                                } else {
                                    UI.message({
                                        title: '',
                                        content: 'Ocurrió un error al agregar la(s) etiqueta(s). Por favor inténtalo otra vez.',
                                        accept: 'Aceptar'
                                    })
                                    UI.hideLoader()
                                }
                            }
                        }).catch(function () {
                            UI.hideLoader()
                            UI.message({
                                title: '',
                                content: 'Ocurrió un error. Por favor inténtalo nuevamente.',
                                accept: 'Aceptar'
                            })
                        })
                    } else {
                        UI.message({
                            title: '',
                            content: 'Debes ingresar por lo menos una etiqueta.',
                            accept: 'Aceptar'
                        })
                    }
                } else {
                    UI.message({
                        title: '',
                        content: 'El producto no es válido.',
                        accept: 'Aceptar'
                    })
                }
            } else {
                UI.message({
                    title: '',
                    content: 'La categoría no es válida.',
                    accept: 'Aceptar'
                })
            }
        } else {
            UI.message({
                title: '',
                content: 'El menú no es válido.',
                accept: 'Aceptar'
            })
        }
    } else {
        UI.message({
            title: '',
            content: 'El establecimiento no es válido.',
            accept: 'Aceptar'
        })
    }
}

// deleteTag({store_id:'pim-42', menu_id:'46', category_id:'59', product_id:'33', tag: 'x'})
function deleteTag(data, callback) {
    if (data.store_id) {
        if (data.menu_id) {
            if (data.category_id) {
                if (data.product_id) {
                    if (data.tag) {
                        UI.showLoader()
                        fetch(
                            BASE_URLS.Dinny.api + `/product-tag/delete/?store_id=${data.store_id}&menu_id=${data.menu_id}&category_id=${data.category_id}&product_id=${data.product_id}&req_id=${new Date().getTime()}`,
                            {
                                credentials: 'include',
                                method: 'post',
                                body: JSON.stringify({
                                    tags: data.tag
                                })
                            }
                        ).then(function (response) {
                            if (response.ok) {
                                UI.hideLoader()
                                callback()
                            } else {
                                response.json().then(function (content) {
                                    if (403 == response.status) {
                                        window.location.href = 'login.html'
                                    } else {
                                        if (content && content.message) {
                                            UI.message({
                                                title: 'Etiquetas',
                                                content: content.message,
                                                accept: 'Aceptar'
                                            })
                                        } else {
                                            UI.message({
                                                title: 'Etiquetas',
                                                content: 'Ocurrió un error al borrar la etiqueta. Por favor inténtalo nuevamente.',
                                                accept: 'Aceptar'
                                            })
                                        }
                                        UI.hideLoader()
                                    }
                                })
                            }
                        }).catch(function () {
                            UI.hideLoader()
                            UI.message({
                                title: 'Etiquetas',
                                content: 'Ocurrió un error. Por favor inténtalo nuevamente.',
                                accept: 'Aceptar'
                            })
                        })
                    } else {
                        UI.message({
                            title: 'Etiquetas',
                            content: 'Debes ingresar por lo menos una etiqueta.',
                            accept: 'Aceptar'
                        })
                    }
                } else {
                    UI.message({
                        title: 'Etiquetas',
                        content: 'El producto no es válido.',
                        accept: 'Aceptar'
                    })
                }
            } else {
                UI.message({
                    title: 'Etiquetas',
                    content: 'La categoría no es válida.',
                    accept: 'Aceptar'
                })
            }
        } else {
            UI.message({
                title: 'Etiquetas',
                content: 'El menú no es válido.',
                accept: 'Aceptar'
            })
        }
    } else {
        UI.message({
            title: 'Etiquetas',
            content: 'El establecimiento no es válido.',
            accept: 'Aceptar'
        })
    }
}



// event listeners
selectMenu.addEventListener("change", () => {
    loadSelectCategories(selectMenu.value);
    selectCategories.disabled = false;
    selectProduct.disabled = true;
});

selectCategories.addEventListener("change", () => {
    loadSelectProducts(selectCategories.value);
    selectProduct.disabled = false;
});

selectProduct.addEventListener("change", () => {
    containerTagsAdded.innerHTML = '';
    loadTags({
        store_id: id_current_store,
        menu_id: selectMenu.value,
        category_id: selectCategories.value,
        product_id: selectProduct.value
    });
    inputSearch.disabled = false;
});

var keyPressTimeout = null;
inputSearch.addEventListener('keyup', () => {
    if (keyPressTimeout) {
        clearTimeout(keyPressTimeout)
    }
    if (inputSearch.value.length >= 3) {
        keyPressTimeout = setTimeout(function () {
            if (/^[a-záéíóúüñÁÉÍÓÚÑÜ]+$/i.test(inputSearch.value)) {
                const searchLowercaseTag = inputSearch.value.toLowerCase();
                getSuggestions(searchLowercaseTag);
            } else {
                clearTimeout(keyPressTimeout)
                UI.message({
                    title: 'Etiquetas',
                    content: 'La etiqueta no es válida.',
                    accept: 'Aceptar'
                }, function () {
                    inputSearch.value = ''
                    inputSearch.focus()
                })
                document.getElementById('ui-saveModal').focus()
            }
        }, 500)
    }
    else {
        labelContainerSuggest.textContent = "";
        containerResultSuggest.innerHTML = "";
    }
});


btnUpdateProduct.addEventListener("click", () => {
    var actions = 0
    if (arrayNewTagsProduct.length == 0 && arrayDeletePreviousTagProduct.length == 0) {
        return UI.message({
            title: 'Etiquetas',
            content: 'No hay etiquetas para actualizar. Por favor agrega o elimina algunas e inténtalo nuevamente.',
            accept: 'Aceptar'
        })
    }
    if (arrayNewTagsProduct.length > 0) {
        actions++
        addTags({
            store_id: id_current_store,
            menu_id: selectMenu.value,
            category_id: selectCategories.value,
            product_id: selectProduct.value,
            tags: arrayNewTagsProduct
        }, function () {
            actions--
            if (actions == 0) {
                UI.message({
                    title: 'Etiquetas',
                    content: 'Se actualizaron correctamente las etiquetas.',
                    accept: 'Aceptar'
                })
            }
            arrayNewTagsProduct = []
        });
    }

    if (arrayDeletePreviousTagProduct.length > 0) {
        actions++
        deleteTag({
            store_id: id_current_store,
            menu_id: selectMenu.value,
            category_id: selectCategories.value,
            product_id: selectProduct.value,
            tag: arrayDeletePreviousTagProduct
        }, function () {
            actions--
            if (actions == 0) {
                UI.message({
                    title: '',
                    content: 'Se actualizaron correctamente las etiquetas.',
                    accept: 'Aceptar'
                })
            }
            arrayDeletePreviousTagProduct = []
        });
    }

});